import { schema } from 'normalizr';
import IntermediaryVariableConfigurationSchema from './IntermediaryVariableConfigurationSchema';

const IntermediaryProfileCardSchema = new schema.Entity('intermediaryProfileCards', {
  fields: [IntermediaryVariableConfigurationSchema],
});

export default IntermediaryProfileCardSchema;
